import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams, useHistory } from 'react-router';
// components
import Button from '@/components/ui/buttons/Button';
import { Form } from 'react-final-form';
import FormSection from '@/components/forms/FormSection';
// types
import { IButtonTypes } from '@/components/ui/buttons/Button/types';
import { SIGN_IN_FORM_FIELDS } from './config';
import api from '@/api';

const CheckinForm = ({ initialValues = {}, onSuccess }) => {
  const dispatch = useDispatch();
  const { eventId } = useParams();
  const handleFormSubmit = ({ email }) => {
    return api.account
      .loginAsGuest(
        {
          email: email,
        },
        eventId,
      )
      .then(({ data }) => {
        dispatch({ type: 'account/setAccount' });
        dispatch({ type: 'account/setUserData', payload: { data } });

        onSuccess && onSuccess(data);
        dispatch({
          type: 'global/addSuccessToast',
          payload: { description: 'Your are successfully Logged in' },
        });
      })
      .catch(e => {
        dispatch({
          type: 'global/addDangerToast',
          payload: { description: 'Invalid Email or Password' },
        });
      });
  };

  return (
    <Form
      onSubmit={handleFormSubmit}
      initialValues={initialValues}
      render={({ handleSubmit, submitting }) => (
        <form onSubmit={handleSubmit}>
          <FormSection formData={SIGN_IN_FORM_FIELDS} styleClass="signIn" />
          <Button
            loading={submitting}
            label="Sign In"
            type="submit"
            styleClass={IButtonTypes.CONTRAST_PRIMARY}
          />
        </form>
      )}
    />
  );
};

export default CheckinForm;
